module.exports = __webpack_public_path__ + "img/CybersecurityAwarenessCurriculum2024.b1b16a08.jpg";